import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import {Helmet} from "react-helmet";

export default function BrokerageForexLicenseMalta (){

    return (
        <main className='main'>

            <Helmet>
                <title>Malta Forex License | MFSA Brokerage License EU</title>
                <meta name="description" content="Get a Malta MFSA forex & brokerage license with EU passporting rights. Operate across EEA under MiFID II regulation and full compliance." />
                <meta name="keywords" content="
                    Malta forex license, MFSA brokerage license, EU forex license, MiFID II license Malta, investment firm license Malta, forex broker license EU, EEA passporting rights, trading platform license Malta
                "
                />
            </Helmet>

            <IntroSection
                title="Brokerage & Forex License – Malta (MFSA)"
                subtitle="Establish Your Investment Firm Under EU Regulation"
                description =
                    "
                        Malta is one of <b>Europe’s leading hubs for forex brokers, investment firms, and trading platforms</b>, regulated by the <b>Malta Financial Services Authority (MFSA)</b>. A license in Malta gives you <b>EU passporting rights under MiFID II</b>, allowing you to provide services across the entire <b>European Economic Area (EEA)</b>.
                    "
                badges={
                    [
                        "Forex & CFD Brokerage",
                        "Investment Dealer",
                        "Portfolio Management",
                        "Custody Services"
                    ]
                }
                buttonText="Request a Malta Brokerage Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/brokerage-forex-license-malta-hero.png")}
                imageAlt="intro section"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Malta for Brokerage?'
                        subtitle='Operating a brokerage without a license limits your growth and credibility. With a license, you gain:'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "EU & Global Recognition",
                                            text: "Tier-1 credibility for brokers and traders."
                                        },
                                        {
                                            title: "MFSA-Regulated",
                                            text: "Aligned with MiFID II and EU directives."
                                        },
                                        {
                                            title: "EU Passporting",
                                            text: "Operate across 30+ EEA countries with a single license."
                                        },
                                        {
                                            title: "Banking & PSP Access",
                                            text: "Easier onboarding with EU banks and liquidity providers."
                                        },
                                        {
                                            title: "Investor Confidence",
                                            text: "Highly respected by institutional and retail clients."
                                        }
                                    ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of Brokerage Licenses (MFSA)"
                        subtitle='Under MiFID II, Malta issues several categories of Investment Services Licenses:'
                        blocks={[
                            {
                                title: "Category 2 Investment Services License",
                                items:
                                    [
                                        { text: "Provide brokerage & execution services." },
                                        { text: "Operate forex/CFD trading platforms (STP, ECN, Market Maker)." },
                                        { text: "Manage client portfolios (discretionary or advisory)." },
                                        { text: "Cannot hold client money (must partner with a custodian)." },
                                        { text: "Capital Requirement: €125,000." }
                                    ]
                            },
                            {
                                title: "Category 3 Investment Services License",
                                items:
                                    [
                                        { text: "Provide all Category 2 services plus custody." },
                                        { text: "Hold & safeguard client money and assets." },
                                        { text: "Provide clearing & settlement services." },
                                        { text: "Full-scale investment dealer license." },
                                        { text: "Capital Requirement: €730,000." }
                                    ]
                            },
                        ]}
                    />

                    <LocationTimeline
                        title="Benefits of a Malta Brokerage License"
                        item={
                            [
                                {
                                    title: "EU Passporting Rights",
                                    text: "Serve clients across the European Economic Area (EEA)."
                                },
                                {
                                    title: "Top-Tier Compliance",
                                    text: "Gain the trust of regulators and investors with robust compliance."
                                },
                                {
                                    title: "Access to EU Banking & Liquidity Providers",
                                    text: "Facilitates smooth operations with banks and liquidity sources."
                                },
                                {
                                    title: "Higher Company Valuations",
                                    text: "Regulated firms command premium market valuations and multiples."
                                },
                                {
                                    title: "Scalable",
                                    text: "Start with Category 2 and upgrade to Category 3 as the business grows."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Consultation & Structuring",
                                    text: "Select Category 2 or 3 license based on your business model."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Establish a Malta-based legal entity for the licensing process."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "Prepare business plan, AML/KYC manuals, financial statements, and corporate governance documents."
                                },
                                {
                                    title: "Submission to MFSA",
                                    text: "Regulatory review including document assessment and interviews with key personnel."
                                },
                                {
                                    title: "System & Compliance Audit",
                                    text: "IT systems and internal controls are audited to ensure compliance."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "License approval and issuance typically occurs within 6–12 months."
                                }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "6–12 months",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Setup Cost",
                                description: "from €75,000+ (legal, compliance, incorporation, license fees)",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Capital Requirement",
                                description: "€125,000 (Cat. 2) | €730,000 (Cat. 3)",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Annual Renewals",
                                description: "ongoing supervision, compliance, and audits required",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Experts in EU investment licensing (MFSA & MiFID II)." },
                                { text: "End-to-end service: company setup, compliance manuals, license filing, ongoing reporting." },
                                { text: "Introductions to Tier-1 liquidity providers, PSPs, and banks." },
                                { text: "Transparent roadmap comparing Malta vs offshore alternatives." }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "
                                Looking for EU credibility and passporting rights?
                             "
                         description=
                             "
                             A <b>Malta brokerage license under MFSA</b> gives your firm <b>Tier-1 recognition</b> and <b>access to the entire EU market</b>.

                             "
                         buttonText='Book a Malta Brokerage License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is the difference between Category 2 and 3?",
        content: [
            { type: "answer", text: "Cat. 2 cannot hold client money, Cat. 3 can hold custody of funds & assets." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Typically 6–12 months, depending on business complexity." },
        ],
    },
    {
        question: "Can I use MT4/MT5 under this license?",
        content: [
            { type: "answer", text: "Yes — regulated Malta brokers operate with full trading software integration." },
        ],
    },
    {
        question: "Do I need a local presence?",
        content: [
            { type: "answer", text: "Yes — at least two resident directors and compliance officers in Malta." },
        ],
    },
    {
        question: "What capital is required?",
        content: [
            { type: "answer", text: "€125,000 for Cat. 2, €730,000 for Cat. 3." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "Offshore Advisory helped us structure our Malta investment firm. The MFSA license gave us EU passporting and credibility.",
            author: "Daniel P.",
            role: "Brokerage CEO"
        },
        {
            quote: "Our forex brokerage was licensed under Category 3 in Malta. Offshore Advisory handled the compliance and liquidity onboarding.",
            author: "Sofia R.",
            role: "Investment Director"
        }
    ]
;